<section class="master_view_sec">
  <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
      <div class="custom-tabs enquiries_custom_tabs">
        <!-- mat-tab-group -->
        <mat-tab-group [@.disabled]="true">
          <!-- Product Details-TAB -->
          <mat-tab class="product-details-tab">
            <ng-template mat-tab-label>
              Product Details
            </ng-template>
            <!-- TABS-BODY -->
            <section class="tabs-body">
              <div class="product_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                <div class="product_details_column" fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60"
                  fxFlex.sm="60" fxFlex.xs="100" fxFlexFill>
                  <div class="enquiries_view_left">
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Product name
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply?.name}} -
                        {{oldSupplyEnquiries?.supply_variant?.title}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Brand
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply?.supply_brand?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Category
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply?.supply_category?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Sub category
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply?.supply_sub_category?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label"> Selling Price
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply_variant?.selling_price}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label"> Actual Price
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.supply_variant?.actual_price}} </p>
                    </div>
                  </div>
                </div>
                <div class="product_details_column" fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40"
                  fxFlex.sm="40" fxFlex.xs="100" fxFlexFill>
                  <div class="enquiries_view_right">
                    <div class="product_img">
                      <img [src]="oldSupplyEnquiries?.supply_variant?.image?.url" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </mat-tab>
          <!-- Product Details-TAB -->
          <mat-tab class="enquire-details-tab">
            <ng-template mat-tab-label>
              Enquire Details
            </ng-template>
            <!-- TABS-BODY -->
            <section class="tabs-body">
              <div class="enquire_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                <div class="enquire_details_column" fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60"
                  fxFlex.sm="60" fxFlex.xs="100" fxFlexFill>
                  <div class="enquiries_view_left">
                    <h4>User Details</h4>
                    <ng-container *ngIf="oldSupplyEnquiries?.dental_supplier">
                      <div class="custom_form_group">
                        <label for="" class="custom_label">User Name
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSupplyEnquiries?.dental_supplier?.name}}</p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Email ID
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSupplyEnquiries?.dental_supplier?.email}}</p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Phone Number
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSupplyEnquiries?.dental_supplier?.phone}}</p>
                      </div>
                    </ng-container>
                    <div class="custom_form_group block_form_group">
                      <label for="" class="custom_label">Message
                        <!-- <span class="dots">:</span> -->
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.message}}</p>
                    </div>
                    <div class="custom_form_group block_form_group">
                      <label for="" class="custom_label">Reply
                        <!-- <span class="dots">:</span> -->
                      </label>
                      <p class="value">{{oldSupplyEnquiries?.reply}}</p>
                    </div>
                  </div>
                </div>
                <div class="enquire_details_column" fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40"
                  fxFlex.sm="40" fxFlex.xs="100" fxFlexFill>
                  <div class="enquiries_view_right" *ngIf="oldSupplyEnquiries?.attachments && oldSupplyEnquiries?.attachments.length">
                    <div class="attachments_list">
                      <h4>Attachments</h4>
                      <ul>
                        <li *ngFor="let singleAttachment of oldSupplyEnquiries?.attachments">
                          <img [src]="singleAttachment.url" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="enquiries_view_right" *ngIf="oldSupplyEnquiries?.reply_attachments && oldSupplyEnquiries?.reply_attachments.length">
                    <div class="attachments_list">
                      <h4>Reply Attachments</h4>
                      <ul>
                        <li *ngFor="let singleAttachment of oldSupplyEnquiries?.reply_attachments">
                          <img [src]="singleAttachment.url" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</section>
